
import React from "react";
import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";
import notFoundImage from "@/assets/404-elf.png";

/**
 * Component shown when a blog post is not found
 */
const BlogPostNotFound = () => {
  // Use our custom SEO hook
  useSEO({
    title: "Post Not Found | Elf Letter Bot",
    description: "The blog post you're looking for could not be found.",
    noIndex: true,
  });

  return (
    <div className="py-16 md:py-24 bg-elfGreen-light">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-elfRed">Blog Post Not Found</h1>
          <p className="text-lg md:text-xl mb-8">
            Sorry, the blog post you're looking for could not be found.
          </p>
          <div className="max-w-md mx-auto mb-8">
            <img
              src={notFoundImage}
              alt="Confused elf with a 404 not found message"
              className="w-full rounded-2xl shadow-lg"
            />
          </div>
          <p className="mb-8 text-lg">
            Don't worry! You can go back to our blog listing to find other interesting posts.
          </p>
          <Link 
            to="/blog/" 
            className="bg-elfRed hover:bg-elfRed-dark text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-300 inline-block"
          >
            Return to Blog
          </Link>
        </div>
    </div>
  );
};

export default BlogPostNotFound;
